var premiumFormStyles = {
    'input': {
        'font-family': 'arial, sans-serif',
        'color': '#555',
        'display': 'block',
        'height': '36px',
        'padding': '0',
        'font-size': '16px',
        'line-height': '1.1em',
        'border': '1px solid #f00 !important'
    },
    'label': {
        'font-family': 'arial, sans-serif',
        'color': '#4e4948',
        'font-size': '15px',
        'font-weight': '700'
    },
    ':disabled': {'cursor': 'not-allowed'},
};

(function($) {

    formHelper.addRule({
        form: '#form-purchase-step-1',
        status: {
            SUCCESS: function() {

                window.redirectPost('/premium-membership/purchase/review-your-purchase', {
                    'flex-response': this.data.flexResponseJSON
                });
            },
            SESSION_EXPIRED: '/premium-membership/purchase/session-expired',
            CAPTURE_CONTEXT_ERROR: '/premium-membership/purchase/purchase-error',
            ERROR: function() {

                this.$form.find('#flex-response').val('');

                if (this.errors[0].code === 'NEWCAPTURECONTEXT') {

                    window.app.loadFlexMicroformScript(this.data.newCaptureContextData, premiumFormStyles);
                }

                lDialog.close();
            }
        },
        xhrReady: function(xhrOptions) {

            window.app.flexCreateToken(xhrOptions, this);
        }
    });

})(jQuery);

jQuery(function initHandlePurchaseStep1Form($) {

    $('#form-purchase-step-1').each(function(index, el) {

        var $form      = $(this);
        var $submitBtn = $form.find('.btn-submit');

        window.app.initializeMicroform();

        var captureContextData = JSON.parse(captureContextDataJSON);

        window.app.loadFlexMicroformScript(captureContextData, premiumFormStyles);

        $form.keydown(function(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
            }
        });

        $submitBtn.click(function() {

            // Display a lDialog loading shadow box
            checkValidityValue = $form[0].checkValidity(); // returns true/false

            if (checkValidityValue === true) {
                // Browser checkValidity is true, load loading ldialog shadow box
                launchLoadingDialog();
            }
        });

        // Membership Price Actions Below
        $(function(){
            $('input[name="membership-id"]:radio').change(function() {
                ajaxApplyMembershipPrice('price');
            });
        });

        $(function(){
            $('#state-province-b').on('change', function() {
                ajaxApplyMembershipPrice('state');
            });
        });

        function ajaxApplyMembershipPrice($status) {

            membershipID = $('input[name=membership-id]:checked', '.form-purchase-step-1').val();
            stateProvince =  $('#state-province-b').val();

            if (membershipID !== '' && stateProvince !== '') {
                $.ajax({
                    method: "POST",
                    url: "/h/premium/ApplyMembershipPrice",
                    dataType: 'JSON',
                    data: { membershipID: membershipID, stateProvince: stateProvince },
                })
                    .done(function( data ) {
                        // Success - Process
                        $('.js-membership-exp-date').html(data.membershipExpDate);
                        $('.js-membership-price').html(data.originalPrice);
                        $('.js-subtotal-price').html(data.membershipPrice);
                        $('.js-tax-cost').html(data.taxCost);
                        $('.js-final-price').html(data.finalPrice);

                        if (data.displayDiscount === 'true') {

                            $('.js-discount-amount').html('-' + data.priceDiscount);
                            $('.js-price-discount').show();
                        } else {
                            $('.js-discount-amount').html('0.00');
                            $('.js-price-discount').hide();
                        }

                        if ($status === 'state') {
                            launchInfoDialog("Your 'Billing State' has been updated and the Trip Summary has been updated to reflect the new Taxes.");
                        }
                        else {
                            var $upgradeText = $('input[name="membership-id"]:checked').parent().text();
                            //launchInfoDialog("The Premium " + $upgradeText + " has been applied.");
                        }
                    })
                    .fail(function() {
                        alert( "An unexpected error has occurred." );
                    });
            }
            else {
                launchInfoDialog("To calculate your Premium Membership Upgrade cost, your Billing State / Province is required.");

                // Set the radio membership to the default / 1st value
                $("input[name=membership-id][value='3']").prop('checked', true);
            }
        }
    });
});


jQuery(function initHandlePurchaseStep2Form($) {

    $('#form-purchase-step-2').each(function(index, el) {

        var $form = $(this);
        var $submitBtn = $form.find('.btn-submit');

        $submitBtn.click(function() {
            // Display a lDialog loading shadow box
            checkValidityValue = $form[0].checkValidity(); // returns true/false

            if (checkValidityValue === true) {
                // Browser checkValidity is true, load loading ldialog shadow box
                launchLoadingDialog();

                setTimeout(function(){
                    $form.submit();
                },1000);
            }
        });
    });
});

